// extracted by mini-css-extract-plugin
module.exports = {"payment-type-input":"payment-type-input-3lhORBt"};